import {
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
} from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";
import useFetch from "../../../../hooks/useFetch";
import "./Req.css";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 145,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  a: {
    textDecoration: "none",
    color: "#000",
  },
}));

const Open = () => {
  const classes = useStyles();
  const [view, setView] = React.useState("");
  const { data } = useFetch("https://abc-backend.onrender.com/api/quotes");

  const handleChange = (event) => {
    setView(event.target.value);
  };
  return (
    <div className="adminTReq">
      <div className="approvalPage">
        <div className="approvalHeading">
          <Grid container spacing={1}>
            <Grid item xs={12} lg={1} md={12}>
              <h5 className="approvalTitle">RFQ No</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={1} md={12}>
              <h5 className="approvalTitle">Product Type</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={2} md={12} className="">
              {" "}
              <h5 className="approvalTitle lg2">Customer Name</h5>
              <input type="text" className="approvalInput lg2" />
            </Grid>
            <Grid item xs={12} lg={1} md={12}>
              {" "}
              <h5 className="approvalTitle">Weight</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={1} md={12}>
              <h5 className="approvalTitle">Size</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={2} md={12} className="">
              <h5 className="approvalTitle lg2">Ready to load</h5>
              <input
                type="date"
                data-date-inline-picker="true"
                className="approvalInput lg2"
              />
            </Grid>
            <Grid item xs={12} lg={1} md={12}>
              <h5 className="approvalTitle">From</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={1} md={12}>
              <h5 className="approvalTitle">To</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={1} md={12}>
              <h5 className="approvalTitle">Type</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={2} md={12} className="lg2">
              <h5 className="approvalTitle">Actions</h5>
            </Grid>
          </Grid>
        </div>
        {data?.map((item) => (
          <>
            {!item.saveDrfat && item.open && (
              <div className="approvalTabel" style={{ paddingLeft: "0px" }}>
                <Grid container spacing={1}>
                  <Grid item xs={12} lg={1} md={12}>
                    <h5 className="approvalTabelTitle">100001</h5>
                  </Grid>
                  <Grid item xs={12} lg={1} md={12}>
                    <h5 className="approvalTabelTitle">
                      {item?.data?.quoteIntValue?.productType}
                    </h5>
                  </Grid>
                  <Grid item xs={12} lg={2} md={12} sm={12} className="">
                    <h5 className="approvalTabelTitle lg2">
                      {
                        item?.data?.loadingUnDetailsValue[0]
                          ?.contactPersonNameFrom
                      }
                    </h5>
                  </Grid>
                  <Grid item xs={12} lg={1} md={12}>
                    <h5 className="approvalTabelTitle">
                      {item?.data?.productDetailsValue[0]?.weight}
                    </h5>
                  </Grid>
                  <Grid item xs={12} lg={1} md={12}>
                    <h5 className="approvalTabelTitle">
                      {" "}
                      {item?.data?.productDetailsValue[0]?.sizeInput}
                    </h5>
                  </Grid>
                  <Grid item xs={12} lg={2} md={12} className="lg2">
                    <h5 className="approvalTabelTitle lg2">
                      {" "}
                      {item?.data?.quoteIntValue?.loadDate}
                    </h5>
                  </Grid>
                  <Grid item xs={12} lg={1} md={12}>
                    <h5 className="approvalTabelTitle">
                      {item?.data?.loadingUnDetailsValue[0]?.locationFrom}
                    </h5>
                  </Grid>
                  <Grid item xs={12} lg={1} md={12}>
                    <h5 className="approvalTabelTitle">
                      {item?.data?.loadingUnDetailsValue[0]?.locationTo}
                    </h5>
                  </Grid>
                  <Grid item xs={12} lg={1} md={12}>
                    <h5 className="approvalTabelTitle">
                      {" "}
                      {item?.data?.quoteIntValue?.transportationType}
                    </h5>
                  </Grid>
                  <Grid item xs={12} lg={2} md={12} className="lg2">
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <InputLabel id="demo-simple-select-autowidth-label">
                        Submit Quote
                      </InputLabel>
                      <Select
                        value={view}
                        onChange={handleChange}
                        displayEmpty
                        defaultValue={"Approve"}
                        inputProps={{ "aria-label": "Without label" }}
                      >
                        <MenuItem
                          value={"Submit Quote"}
                          className="admin_view_quote"
                        >
                          <Link to={`/siteadmin/admin-quotes/${item._id}`}>
                            Submit Quote
                          </Link>{" "}
                        </MenuItem>
                        <MenuItem value={"Submit Quote"}>View</MenuItem>
                        <MenuItem value={"Submit Quote"}>Reject</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </div>
            )}
          </>
        ))}
      </div>
    </div>
  );
};

export default Open;
